import ToastMessage from "~/common/components/Messages/ToastMessage/ToastMessage";
import { type MessageType } from "~/common/components/Messages/Message";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export interface Props {
  type: MessageType;
  message: string;
  dismissable: boolean;
}

const ExternalToastMessage = ({ type, message }: Props) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);
  if (!visible) {
    return false;
  }
  return (
    <ToastMessage type={type} onClose={() => setVisible(false)}>
      {t(message)}
    </ToastMessage>
  );
};

const validTypes: MessageType[] = ["info", "error"];

export function create(props: Props) {
  const type = validTypes.indexOf(props.type) !== -1 ? props.type : "info";

  return <ExternalToastMessage type={type} message={props.message} dismissable={props.dismissable} />;
}
